import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=c5624238&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=ts&"
export * from "./reset-password.vue?vue&type=script&lang=ts&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=c5624238&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5624238",
  null
  
)

export default component.exports